import { useTranslation } from 'react-i18next';
import CloseIcon from './CloseIcon';
import { APP_COLOR } from './Common.constants';
import { SimpleCancelButtonTheme } from './Common.types';

interface SimpleCancelButtonProps {
  theme: SimpleCancelButtonTheme;
  isDisabled?: boolean;
  onClick?: () => void;
  className?: string;
}

const ICON_SIZE = 8;

export default function SimpleCancelButton({
  theme,
  isDisabled = false,
  onClick,
  className,
}: SimpleCancelButtonProps) {
  const [translate] = useTranslation();
  const isBlueTheme = theme === SimpleCancelButtonTheme.BLUE;
  const textColor = isBlueTheme ? 'text-main-ui-blue' : 'text-white';
  const iconColor = isBlueTheme
    ? APP_COLOR['main-ui-blue']
    : APP_COLOR['icon-white'];
  const opacity = isDisabled ? 'opacity-50' : 'opacity-100';

  return (
    <button
      type="button"
      className={`flex flex-row items-center justify-center ${opacity} cursor-pointer focus:opacity-100 outline-none hover:opacity-80 ${className}`}
      disabled={isDisabled}
      onClick={onClick}
    >
      <CloseIcon color={iconColor} size={ICON_SIZE} />
      <div className={`text-14px ml-2 ${textColor} font-bold font-body`}>
        {translate('CANCEL_SMALL')}
      </div>
    </button>
  );
}
